import React, { Fragment, useEffect, useMemo, useState } from 'react'
import CommonFilter from '../../../customControl/CommonFilter'
import CustomTable from '../../../customControl/CustomTable'
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../_actions/loader.actions';
import { ClearLocalStorage } from '../../../components/commonClass/Session';
import { userrights } from '../../../components/commonClass/CommonInterfaceTypes';
import { getuserprofileimagebyid } from '../../../components/commonClass/CommonFunctions';
import StatusActionModal from '../../../customControl/StatusActionModal';
import { AgentStatus } from '../../../_constants/agent.constant';
import { agentActions } from '../../../_actions/agent.action';

function TravelAgentList() {

    interface outletcontext {
        userRights: userrights
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [datalist, setDataList] = useState<any>([]);
    const [filterlist, setFilterList] = useState<any>([]);
    const OutletContext: outletcontext = useOutletContext();
    const [loginUserDomainMasterId, setLoginUserDomainMasterId] = useState(0); // 1 - Internal, 2 - TA (Travel Agent), 3 - Corporate 

    const [searchby, setSerachBy] = useState('All');
    const [searchvalue, setSearchValue] = useState('');

    const [modalConfig, setModalConfig] = useState({
        show: false,
        actionType: 'View' as 'Approve' | 'Reject' | 'View',
        viewData: { Remark: '', RejectionReason: '' },
        TravelAgentId: 0
    });

    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const { data: agentData } = useSelector((store: any) => store.agentOptions);

    const actionOptions = useMemo(() => {
        return (agentData?.statusOptions || []).filter((opt: any) =>
            !([AgentStatus.Pending, AgentStatus.Submit, AgentStatus.ReSubmit] as number[]).includes(Number(opt.StatusId))
        );
    }, [agentData?.statusOptions]);

    const gettravelagentlist = async () => {
        const travelagentlist = await getAllData('/midoffice/v1/gettravelagentlist');
        if (travelagentlist?.status && Array.isArray(travelagentlist?.data)) {
            travelagentlist.data.map((obj: any, index: number) => {
                obj.SrNo = index + 1
                return obj;
            })
            setDataList(travelagentlist.data);
            setFilterList(travelagentlist.data);
        }
        else {
            setDataList([]);
            setFilterList([]);
        }
    }

    const columns: any = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            minWidth: "80px",
            maxWidth: "85px",
            isSearch: false,
            isExport: false,
            selector: (listData: any) => listData?.SrNo,
            omit: false
        },
        {
            name: 'TA ID',
            key: 'TravelAgentCode',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.TravelAgentCode,
        },
        {
            name: 'Company Name',
            key: 'NameOfCompany',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.NameOfCompany,
        },
        {
            name: 'Email ID',
            key: 'EmailId',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.EmailId,
        },
        {
            name: 'Phone No.',
            key: 'PhoneNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.PhoneNo,
        },
        {
            name: 'Sales Manager',
            key: 'SalesManagerName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.SalesManagerName,
        },
        {
            name: 'KAM Manager',
            key: 'KAMManagerName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.KAMManagerName,
        },
        {
            name: 'Region',
            key: 'RegionName',
            sortable: true,
            float: "left",
            minWidth: "85px",
            maxWidth: "90px",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.RegionName,
        }, ,
        {
            name: 'Status',
            sortable: true,
            float: 'left',
            minWidth: '100px',
            selector: (listData: any) => {
                const statusId = Number(listData?.StatusId || listData?.statusId || AgentStatus.Submit);
                const statusName = listData?.StatusName || listData?.Status || 'Submit';
                return (
                    <span
                        className={statusId === AgentStatus.Submit ? 'text-warning' : statusId === AgentStatus.Approved ? 'text-success' : 'text-danger'}
                        style={{ cursor: 'pointer', textDecoration: (statusId === AgentStatus.Approved || statusId === AgentStatus.Rejected) ? 'underline' : 'none' }}
                        onClick={() => {
                            if (statusId === AgentStatus.Approved || statusId === AgentStatus.Rejected) {
                                setModalConfig({
                                    show: true,
                                    actionType: 'View',
                                    viewData: {
                                        Remark: listData?.ApprovalRemark,
                                        RejectionReason: listData?.ReasonText
                                    },
                                    TravelAgentId: listData?.TravelAgentId
                                });
                            }
                        }}
                    >
                        {statusName}
                    </span>
                );
            }
        },
        {
            name: 'Action',
            minWidth: '130px',
            omit: loginUserDomainMasterId !== 1,
            selector: (listData: any) => {
                const statusId = Number(listData?.StatusId || listData?.statusId || AgentStatus.Submit);
                const actionOptions = (agentData?.statusOptions || []).filter((opt: any) => !([AgentStatus.Pending, AgentStatus.Submit, AgentStatus.ReSubmit] as number[]).includes(Number(opt.StatusId)));

                if (statusId === AgentStatus.Submit) {
                    return (
                        <select
                            className="form-select form-select-sm"
                            onChange={(e) => {
                                const action = e.target.value;
                                if (action && action !== '') {
                                    setModalConfig({
                                        show: true,
                                        actionType: action as any,
                                        viewData: { Remark: '', RejectionReason: '' },
                                        TravelAgentId: listData?.TravelAgentId
                                    });
                                }
                                e.target.value = ''; // Reset select after action
                            }}
                        >
                            <option value="">Select</option>
                            {actionOptions.map((opt: any, index: number) => (
                                <option key={index} value={opt?.StatusName === 'Approved' ? 'Approve' : opt?.StatusName === 'Rejected' ? 'Reject' : opt?.StatusName}>
                                    {opt?.StatusName}
                                </option>
                            ))}
                        </select>
                    );
                }
                return <span>-</span>;
            }
        },
        {
            name: 'Edit',
            selector: (listData: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!OutletContext?.userRights?.URightEdit}><i className="fa-regular fa-pen-to-square" onClick={() => handleEdit(listData, listData?.TravelAgentId)}></i></button>
        },
        {
            name: 'View',
            selector: (listData: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr'><i className="fa-regular fa-eye" onClick={() => handleView(listData, listData?.TravelAgentId)}></i></button>
        }
    ];


    const getLoginUserDomianId = async () => {
        const userById = await getuserprofileimagebyid();
        if (userById?.status) {
            setLoginUserDomainMasterId(userById?.data?.[0]?.DomainMasterId)
        }
    }

    useEffect(() => {
        async function fetchData() {
            localStorage.removeItem("taid");
            dispatch(loaderActions.start())
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.all([
                    getLoginUserDomianId(),
                    gettravelagentlist()
                ])
                dispatch(loaderActions.end())
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }

        }
        fetchData();
    }, [])

    const handleOpen = () => {
        navigate('/travel-agent-management/create-agent', { state: { disabled: false, editdisabled: false, type: 'Add', Id: 0, datalist: datalist } });
    }

    const handleEdit = (itemData: any, id: number) => {
        navigate('/travel-agent-management/create-agent', { state: { disabled: false, editdisabled: true, type: 'Edit', Id: id, itemData: itemData, datalist: datalist } });
    }

    const handleView = (itemData: any, id: number) => {
        navigate('/travel-agent-management/create-agent', { state: { disabled: true, editdisabled: true, type: 'View', Id: id, itemData: itemData, datalist: datalist } });
    }

    useEffect(() => {
        (dispatch as any)(agentActions.getAgentOptions());
    }, []);

    return (
        <Fragment>
            <div className="m-2 heading_color d-flex justify-content-between">
                <h4>Travel Agent  List</h4>
                {
                    loginUserDomainMasterId === 1 &&
                    <button type="button" disabled={!OutletContext?.userRights?.URightAdd} className="btn btn-primary" id="btnAdd" onClick={handleOpen} >+ Add TA</button>
                }
            </div>
            <div className="m-2 mt-5">
                <form action="" className='mt-3'>
                    <div className="d-flex justify-content-start">
                    </div>
                    <CommonFilter
                        filtercolumns={columns}
                        filteritems={filterlist}
                        setFilterList={setDataList}
                        getdata={gettravelagentlist}
                        // serchdisable={serchdisable}
                        setSearchValue={setSearchValue}
                        searchvalue={searchvalue}
                        setSerachBy={setSerachBy}
                        searchby={searchby}
                    />

                    <CustomTable
                        className={"last_two_column_freeze"}
                        columns={columns}
                        data={datalist}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={false}
                    />
                </form>
            </div >

            <StatusActionModal
                show={modalConfig.show}
                onHide={() => setModalConfig({ ...modalConfig, show: false })}
                actionType={modalConfig.actionType}
                viewData={modalConfig.viewData}
                TravelAgentId={modalConfig.TravelAgentId}
                onSuccess={() => {
                    gettravelagentlist();
                }}
            />
        </Fragment>
    )
}

export default TravelAgentList